import React, { useState, useEffect } from "react";

import "../assests/css/contact-modal.scss";

import emailjs from "emailjs-com";

import { IoClose } from "react-icons/io5";

const Modal = () => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  const handleOutsideClick = (e) => {
    if (e.target.id === "modal-overlay") {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    document.title = "Get in Touch | Reach Out to Haantlay";
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    email: "",
    phone: "",
    company: "",
    title: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const button = document.getElementById("submitButton");
    button.innerHTML = '<span class="loading-dark"></span> Submitting...';
    button.disabled = true;

    // Email validation
    const emailExp = /^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{2,}$/i;
    const emailError =
      !formData.email || !emailExp.test(formData.email)
        ? "Please enter a valid email"
        : "";

    setErrors({
      ...errors,
      email: emailError,
    });

    // Check if there are any errors
    for (const key in formData) {
      if (formData[key] === "" || (key === "email" && emailError !== "")) {
        button.innerHTML = "Submit"; // Reset button on error
        button.disabled = false;
        return; // Exit if validation fails
      }
    }

    // Send form data to EmailJS
    try {
      const result = await emailjs.send(
        "service_ak00qma", // Replace with your EmailJS service ID
        "template_87ptiwb", // Replace with your EmailJS template ID
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          city: formData.city,
          company: formData.company,
          title: formData.title,
          description: formData.description,
        },
        "RvsDOXBIfGXg9jYPG" // Replace with your EmailJS public key
      );

      if (result.text === "OK") {
        window.open("/feedback/success", "_self");
      } else {
        alert("Failed to send the message. Please try again later.");
        button.innerHTML = "Submit"; // Reset button on failure
        button.disabled = false;
      }
    } catch (error) {
      console.error("Error:", error);
      window.open("/feedback/error", "_self");
      button.innerHTML = "Submit"; // Reset button on error
      button.disabled = false;
    }
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        id="button-light-bg"
        className="text-dicoration-none margin-bottom"
      >
        GET IN TOUCH
      </button>

      {isOpen && (
        <div id="modal-overlay" onClick={handleOutsideClick}>
          <section
            id="modal-getintouch"
            className="col-sm-10 col-md-7 col-lg-12 container"
          >
            <div className="modal-button-div">
              <button onClick={() => setIsOpen(false)} className="modal-button">
                <IoClose />
              </button>
            </div>
            <div className="container-sm">
              <div className="form col-md-12 col-lg-12">
                <div>
                  <h6>Get in touch</h6>
                  <h2>How can we help you</h2>
                  <p>Please fill the form below</p>
                </div>
                <form className="contactForm" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className={`form-control form-control-cus ${
                          errors.name && "error"
                        }`}
                        type="text"
                        name="name"
                        placeholder="Your name*"
                        value={formData.name}
                        onChange={handleChange}
                        minLength="5"
                        required
                      />
                    </div>
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className={`form-control form-control-cus ${
                          errors.city && "error"
                        }`}
                        type="text"
                        name="city"
                        placeholder="City*"
                        value={formData.city}
                        onChange={handleChange}
                        minLength="3"
                        required
                      />
                    </div>
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className={`form-control form-control-cus ${
                          errors.email && "error"
                        }`}
                        type="email"
                        name="email"
                        placeholder="Email address*"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      {errors.email && (
                        <div
                          className="validation-s"
                          style={{ display: "block" }}
                        >
                          {errors.email}
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className="form-control form-control-cus"
                        type="tel"
                        name="phone"
                        placeholder="Phone number*"
                        value={formData.phone}
                        onChange={handleChange}
                        pattern="\+[0-9]{7,15}"
                        title="Start with '+' and 7 to 15 digits without hyphens (-) or spaces allowed."
                        required
                      />
                    </div>
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className="form-control form-control-cus"
                        type="text"
                        name="company"
                        placeholder="Company name*"
                        value={formData.company}
                        onChange={handleChange}
                        minLength="3"
                        required
                      />
                    </div>
                    <div className="form-group col-md-12 col-lg-6 mb-2">
                      <input
                        className="form-control form-control-cus"
                        type="text"
                        name="title"
                        placeholder="Your title/role*"
                        value={formData.title}
                        onChange={handleChange}
                        minLength="3"
                        required
                      />
                    </div>
                  </div>
                  <textarea
                    className="form-control height-large"
                    name="description"
                    id="contact-description"
                    rows="4"
                    placeholder="Please tell us a bit about what you're looking for*"
                    value={formData.description}
                    onChange={handleChange}
                    minLength="4"
                    required
                  ></textarea>
                  <button type="submit" id="submitButton">
                    SUBMIT
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default Modal;
